import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { SnackService } from 'src/app/services/snack.service';
import { MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

export interface AppSnackConfig<D = any> extends MatSnackBarConfig<D> {
  durationAfterLeave?: number;
  dismissOnClick?: boolean;
};

@Component({
  template: '',
  standalone: false
})
export abstract class AppSnackBaseComponent {
  message: string;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public snackBarRef: MatSnackBarRef<any>) { }

  ngAfterViewInit() {
  }

  @HostListener('click')
  onClick() {
    if (this.config?.dismissOnClick) {
      this.snackBarRef.dismiss();
    }
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.disableTimeout();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.enableTimeout();
  }

  disableTimeout() {
    let snackBarRef = <any>this.snackBarRef;

    if (snackBarRef._durationTimeoutId) {
      clearTimeout(snackBarRef._durationTimeoutId);
    }
  }

  enableTimeout() {
    let snackBarRef = <any>this.snackBarRef;

    let duration = this.config?.durationAfterLeave ?? this.config?.duration;

    snackBarRef._dismissAfter(duration);
  }

  refreshTimeout() {
    this.disableTimeout();
    this.enableTimeout();
  }

  get config() {
    return <AppSnackConfig<any>>this.snackBarRef.containerInstance?.snackBarConfig;
  }
}
